export default function ($translate) {
    return {
        KEYS: {
            EVALUATOR: 'EVALUATOR',
            EVALUABLE: 'EVALUABLE'
        },
        LABELS: {
            EVALUATOR: $translate.instant('evaluation.Evaluator'),
            EVALUABLE: $translate.instant('evaluation.Evaluable')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/evaluation/grouped/type/index.js